import * as React from 'react';
export const IcTeddyLove = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 18.29l-.49-.29a4.198 4.198 0 00-.05-4 2 2 0 00-.85-3.9l-2.4.48A4.469 4.469 0 0017 6.5a4.41 4.41 0 00-.08-.73A2 2 0 0016 2a2 2 0 00-1.46.64 5.36 5.36 0 00-5.08 0A2 2 0 008 2a2 2 0 00-.92 3.77c-.047.24-.074.485-.08.73a4.47 4.47 0 002.79 4l-2.4-.5a2 2 0 00-.85 3.9 4.2 4.2 0 000 4l-.54.39A2 2 0 007 22a1.94 1.94 0 001-.29l1.8-1.06c1.43.467 2.97.467 4.4 0l1.8 1.06c.3.186.646.286 1 .29a2 2 0 001-3.71zm-7-13a1 1 0 001.9 0 2 2 0 11-1.9 0zm3.86 11.16l-2.56 2.5a.5.5 0 01-.7 0l-2.56-2.5a2 2 0 01.6-3.25 2 2 0 012.23.43l.08.08.08-.08a2 2 0 012.88 2.78l-.05.04z'
      fill='currentColor'
    />
  </svg>
);
